import React, { useEffect, useRef } from 'react';
import { View, Animated, StyleSheet, ActivityIndicator, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Paprika, PaprikaSpacing, PaprikaTypography } from '../../styles/theme';

interface RecipeFetchSkeletonProps {
  section: 'ingredients' | 'steps';
}

export const RecipeFetchSkeleton: React.FC<RecipeFetchSkeletonProps> = ({ section }) => {
  const { t } = useTranslation();
  const shimmer = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(shimmer, { toValue: 1, duration: 900, useNativeDriver: true }),
        Animated.timing(shimmer, { toValue: 0, duration: 900, useNativeDriver: true }),
      ])
    ).start();
  }, [shimmer]);

  const opacity = shimmer.interpolate({ inputRange: [0, 1], outputRange: [0.4, 0.9] });

  const widths = section === 'ingredients'
    ? ['85%', '65%', '75%', '50%']
    : ['90%', '70%', '80%', '60%'];

  return (
    <View style={styles.container}>
      {widths.map((width, i) => (
        <Animated.View key={i} style={[styles.bar, { width: width as any }, { opacity }]} />
      ))}
      <View style={styles.footer}>
        <ActivityIndicator size="small" color={Paprika.textMuted} />
        <Text style={styles.label}>{t('recipeDetail.fetchingFromSource')}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: PaprikaSpacing.lg,
    paddingVertical: PaprikaSpacing.xl,
    gap: PaprikaSpacing.md,
  },
  bar: {
    height: 14,
    borderRadius: 7,
    backgroundColor: Paprika.surfaceHighest,
  },
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: PaprikaSpacing.xs,
    marginTop: PaprikaSpacing.sm,
  },
  label: {
    ...PaprikaTypography.bodySmall,
    color: Paprika.textMuted,
  },
});
